<template>
  <div class="container">

    <div class="large-12 medium-12 small-12 filezone card">
      <input type="file" id="files" name="avatar" ref="files" multiple v-on:change="handleFiles()" />
      <p>
        Drop your files here
        <br>or click to search
      </p>




    </div>
    <div class="error_msg_fatal"></div>

    <div class="mt-2 card" v-show="files.length > 0">
      <div class="card-body row">
        <div class="col">
          <div class="submit-button btn btn-lg btn-success" v-on:click="submitFiles()">Submit <i v-if="loading" class="fas fa-spinner fa-spin"></i></div>
        </div>
      </div>
    </div>

    <div v-for="(file, key) in files" class="file-listing card mt-2">
      <div class="card-body row">
        <div class="col d-flex align-items-center">
          <img class="preview img-fluid" v-bind:ref="'preview'+parseInt(key)" /> 
        </div>
        <div class="col d-flex align-items-center">
          {{ file.name }}
          <div class="error_msg"></div>
        </div>

        <div class="col  d-flex align-items-center float-right">
          <div class="success-container w-100 text-right" v-if="file.id > 0">Success</div>
          <div class="remove-container w-100" v-else>
            <div class="remove btn btn-danger btn float-right" v-on:click="removeFile(key)">Remove</div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
</template>

<script>
  export default {
    props: [
    'post_url',
    'tag',
     'variant'
    ],
    data() {
      return {
        files: [],
        loading: false
      }
    },
    methods: {
      handleFiles() {
        let uploadedFiles = this.$refs.files.files;

        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push(uploadedFiles[i]);
        }
        this.getImagePreviews();
      },

      getImagePreviews() {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
            let reader = new FileReader();
            reader.addEventListener("load", function() {
              this.$refs['preview' + parseInt(i)][0].src = reader.result;
            }.bind(this), false);
            reader.readAsDataURL(this.files[i]);
          } else {
            this.$nextTick(function() {
             this.$refs['preview'+parseInt(i)][0].src = '/images/generic.png';
          });
          }
        }

      },

      removeFile(key) {
          $('.error_msg').html('');
          var self = this;
        this.files.splice(key, 1);
          setTimeout(function() {
              self.getImagePreviews();
          },100)
      },

      submitFiles() {

       this.loading = true;



          $('.error_msg').html('');
        let formData = new FormData();

        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          formData.append('files[' + i + ']', file);
        }

        formData.append('tag', this.tag );
        formData.append('variant', this.variant);

          axios.post(this.post_url,
              formData,
              {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              })
              .then(function (response) {
                  $(".card").css('animation', 'hideCard .1s');
                  setTimeout(function() {
                      location.href = document.referrer
                  }, 1000);
              })
              .catch(function (error) {
                  if(Object.getOwnPropertyDescriptor(error, 'message').value.includes("413")){
                      $('.error_msg_fatal').html('<p class="error_msg">Er ging iets fout tijdens het uploaden</p>');
                  }else {
                      $('.file-listing').each(function (index) {
                          if (error.response.data.errors['files.' + index]) {
                              $(this).find('.error_msg').html('<p class="error_msg">' + error.response.data.errors['files.' + index] + '</p>')

                          }
                      })
                  }
              });
                }
              }
            }
          </script>

          <style scoped>
            .error_msg{
              color: red;
              margin-left: 82px;
            }
            .error_msg_fatal{
              color: red;
            }
          input[type="file"] {
            opacity: 0;
            width: 100%;
            height: 200px;
            position: absolute;
            cursor: pointer;
          }

          .filezone {
            outline: 2px dashed grey;
            outline-offset: -10px;
            background: #ccc;
            color: dimgray;
            padding: 10px 10px;
            min-height: 200px;
            position: relative;
            cursor: pointer;
          }

          .filezone:hover {
            background: #c0c0c0;
          }

          .filezone p {
            font-size: 1.2em;
            text-align: center;
            padding: 50px 50px 50px 50px;
          }

          div.file-listing img {
            max-width: 90%;
          }

          div.file-listing {
            margin: auto;
            padding: 10px;
            border-bottom: 1px solid #ddd;
          }

          div.file-listing img {
            height: 100px;
          }

          div.success-container {
            text-align: center;
            color: green;
          }

          div.remove-container {
            text-align: center;
          }

          div.remove-container a {
            color: red;
            cursor: pointer;
          }

          a.submit-button {
            display: block;
            margin: auto;
            text-align: center;
            width: 200px;
            padding: 10px;
            text-transform: uppercase;
            background-color: #CCC;
            color: white;
            font-weight: bold;
            margin-top: 20px;
          }
        </style>



// WEBPACK FOOTER //
// resources/js/components/UploadFiles.vue